import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import MainButton from "../Components/Buttons/MainButton";

const MODAL_SX = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "min(620px, calc(100vw - 32px))",
  bgcolor: "background.paper",
  boxShadow: "0 32px 80px rgba(15, 23, 42, 0.24)",
  p: 0,
  borderRadius: "30px",
  overflow: "hidden",
  border: "1px solid rgba(255,255,255,0.6)",
};

function DeleteResourceModal({
  title,
  description,
  open,
  handleClose,
  handleDelete,
  resourceId,
}) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={MODAL_SX}>
        <div className="relative flex h-[120px] w-full items-center justify-center overflow-hidden border-b border-white/25 bg-[linear-gradient(135deg,rgba(255,147,87,0.98)_0%,rgba(241,93,34,0.95)_52%,rgba(255,124,50,0.92)_100%)] shadow-[inset_0_1px_0_rgba(255,255,255,0.22)] backdrop-blur-xl">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(255,255,255,0.18),transparent_58%)]" />
          <div className="relative flex h-[62px] w-[62px] items-center justify-center rounded-full border border-white/40 bg-white/10 shadow-[inset_0_1px_0_rgba(255,255,255,0.3)]">
            <ErrorOutlineIcon sx={{ width: "38px", height: "38px", color: "#FFFFFF" }} />
          </div>

          <IconButton
            sx={{
              position: "absolute",
              right: 14,
              top: 14,
              color: "#FFFFFF",
              backgroundColor: "rgba(255,255,255,0.12)",
              border: "1px solid rgba(255,255,255,0.18)",
              backdropFilter: "blur(10px)",
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.18)",
              },
            }}
            onClick={() => handleClose(false)}
          >
            <CloseIcon fontSize="large" />
          </IconButton>
        </div>

        <div className="flex w-full flex-col px-7 py-6 md:px-8 md:py-7">
          <h3 className="mb-4 text-[24px] font-black text-[#f15d22]">
            {title}
          </h3>
          <p className="mb-7 text-[16px] leading-8 text-slate-600">{description}</p>
          <div className="flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
            <MainButton
              destructive={true}
              text={title}
              onClick={() => handleDelete(resourceId)}
            />
            <MainButton
              text={"Do Not Delete"}
              onClick={() => handleClose(false)}
              secondary={true}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default DeleteResourceModal;
